<div class="modern-header">
    <!-- Left section with hamburger and search -->
    <div class="header-left">
        <li class="nav-item hamburger-menu">
            <a class="nav-link" (click)="onToggleMenuSidebar()" role="button">
                <i class="fas fa-bars"></i>
            </a>
        </li>

        <!-- <form class="search-form" [formGroup]="searchForm">
            <div class="search-container">
                <input
                    class="search-input"
                    type="search"
                    placeholder="Search"
                    aria-label="Search"
                />
                <button class="search-btn" type="submit">
                    <i class="fas fa-search"></i>
                </button>
            </div>
        </form> -->
    </div>

    <!-- Right section with notifications and user profile -->
    <div class="header-right">
        <app-notifications class="notification-wrapper"></app-notifications>

        <pf-dropdown
            [hideArrow]="true"
            class="user-profile-dropdown"
            direction="left"
        >
            <div slot="button">
                <a class="profile-link" (click)="closeDropdownmain()">
                    <img
                        src="{{
                            userDetail?.profilePicture ||
                                'assets/img/profile.png'
                        }}"
                        alt="User Avatar"
                        class="profile-avatar"
                    />
                    <div class="profile-info">
                        <div class="profile-name">
                            {{ userDetail?.name }}
                        </div>
                        <div class="profile-email">{{ userDetail?.email }}</div>
                    </div>
                </a>
            </div>
            <div slot="menu" *ngIf="visible" class="user-menu-dropdown">
                <a
                    routerLink="/user-settings"
                    class="dropdown-item user-menu-item"
                    (click)="closeDropdown()"
                >
                    Profile
                </a>
                <a
                    routerLink="#"
                    (click)="logout()"
                    class="dropdown-item user-menu-item"
                >
                    Logout
                </a>
            </div>
        </pf-dropdown>
        <span class="nav-item task-menu">
            <a
                class="nav-link"
                (click)="onToggleTaskSidebar()"
                role="button"
                title="Tasks List"
            >
                <i class="fas fa-tasks"></i>
            </a>
        </span>
    </div>
</div>
